import React, {createContext, useState} from 'react';

let OrderDetailContext;
const { Provider } = (OrderDetailContext = createContext({}));

const OrderDetailProvider = ({ children}) => {
    const [isInReplacement, setIsInReplacement] = useState(false);

    const startReplacement = () => {
        setIsInReplacement(true)
    }

    const endReplacement = () => {
        setIsInReplacement(false)
    }

    return (
        <Provider value={{isInReplacement,startReplacement,endReplacement}}>
            {children}
        </Provider>
    )
}

export { OrderDetailContext, OrderDetailProvider };
